import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  const loc = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-950 text-slate-400 text-xs font-semibold">
        Loading workspace…
      </div>
    );
  }

  if (!user) return <Navigate to="/signin" state={{ from: loc }} replace />;

  const isMasterOrAdmin =
    ["admin", "master"].includes(user.role) ||
    user.email === "colibrisocialclub@gmail.com" ||
    user.email === "thyzfoto@gmail.com" ||
    user.email === "admin@weddingsthyzfoto.com" ||
    user.email === "contact@amanbiswalthakur.in";

  if (adminOnly && !isMasterOrAdmin) {
    toast.error("Master Admin credentials required to access Admin Portal.");
    return <Navigate to="/signin" state={{ from: loc }} replace />;
  }

  // First-run redirect: only for non-master users who haven't completed onboarding
  const onboardingPath = loc.pathname === "/onboarding";
  if (user.onboarding_complete === false && !isMasterOrAdmin && !onboardingPath) {
    return <Navigate to="/onboarding" replace />;
  }

  // Trial & Subscription Plan Enforcement:
  // Layout.jsx handles in-canvas gating (<TrialExpiredLockView />) and dims sidebar options,
  // allowing the user to view all platform options while features remain locked with the 404 warning.
  return children;
}
